import { render, staticRenderFns } from "./alarm-message.vue?vue&type=template&id=2b6ef474&"
import script from "./alarm-message.vue?vue&type=script&lang=js&"
export * from "./alarm-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports